import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CouponRegionEntity } from '../../domain/entities/CouponRegionEntity'

export class CouponRegionModel extends CouponRegionEntity {
  constructor(dataDto: CouponRegionEntity) {
    super()
    mapEntityProperties<CouponRegionModel>(this, dataDto)
  }
}
